import useBasicPlanOnlyCustomer from "../hooks/useBasicPlanOnlyCustomer";
import useElevatedRiskMonitoringBanner from "../hooks/useElevatedRiskMonitoringBanner";
import usePropertyUpgradeNavigation from "../hooks/usePropertyUpgradeNavigation";

export const ElevatedRiskProtectionBanner = () => {
  const { isBasicPlanOnly, subscriptionsLoaded } = useBasicPlanOnlyCustomer();
  const { showBanner, loading } = useElevatedRiskMonitoringBanner();
  const { goToPropertyUpgrade, firstAtRiskPropertyId } =
    usePropertyUpgradeNavigation();

  if (!showBanner || loading || !subscriptionsLoaded) {
    return null;
  }

  const linkLabel = isBasicPlanOnly ? "Upgrade my account" : "Protect them NOW";

  return (
    <div
      className="relative z-30 w-full border-b border-red-200/80 bg-red-50/90"
      role="status"
    >
      <div className="px-3 py-2.5 sm:px-4">
        <p className="text-center text-xs leading-snug text-red-950 sm:text-sm">
          1 or more properties are at medium – high risk. Protect them before
          fraudsters can target your equity.{" "}
          <button
            type="button"
            onClick={() => goToPropertyUpgrade(firstAtRiskPropertyId)}
            className="font-semibold text-red-700 underline underline-offset-2 hover:text-red-800"
          >
            {linkLabel}
          </button>
        </p>
      </div>
    </div>
  );
};

export default ElevatedRiskProtectionBanner;
